import { cn } from "@/libraries/cn";
import { CONTACT_DIRECTORY_SCOPE } from "@/libraries/constant";
import type { ContactDirectoryScope } from "@/libraries/constant";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import { useLocation, useNavigate, useSearch } from "@tanstack/react-router";
import { useCallback } from "react";

const tglBtnItems = [
	{
		value: CONTACT_DIRECTORY_SCOPE.ALL_TEAMS,
		label: "All",
	},
	{
		value: CONTACT_DIRECTORY_SCOPE.CASE_TEAMS,
		label: "Case Teams",
	},
	{
		value: CONTACT_DIRECTORY_SCOPE.INTEREST_GROUPS,
		label: "Interest Groups",
	},
] as const;

const FilterTeams = () => {
	const pathname = useLocation({
		select: (location) => location.pathname,
	});
	const isContact = pathname.includes("/contacts/contact");
	const scope = useSearch({
		strict: false,
		select: (search) => search.scope ?? CONTACT_DIRECTORY_SCOPE.ALL_TEAMS,
	});
	const navigate = useNavigate({
		from: isContact
			? "/dashboard/contacts/contact/teams"
			: "/dashboard/contacts/directory/teams",
	});

	const onChangeScope = useCallback(
		(e: React.MouseEvent<HTMLElement>, value: ContactDirectoryScope) => {
			e?.preventDefault();
			if (value === scope) return;
			return navigate({
				search: {
					q: undefined,
					scope: value,
				},
				replace: true,
			});
		},
		[navigate, scope],
	);

	return (
		<div className="relative container flex gap-1 justify-between py-3">
			<ToggleButtonGroup
				value={scope}
				exclusive
				aria-label="Team Scope"
				size="small"
				className="gap-2"
				onChange={onChangeScope}
			>
				{tglBtnItems.map((item) => (
					<ToggleButton
						key={item.value}
						value={item.value}
						aria-label="left aligned"
						className={cn(
							"!rounded-full !normal-case !text-zinc-950 !bg-white !border !border-zinc-300 !py-2 !px-3",
							"[&.Mui-selected]:!border-none [&.Mui-selected]:!bg-primary [&.Mui-selected]:!text-white",
						)}
					>
						<Typography fontWeight={500} fontSize={12}>
							{item.label}
						</Typography>
					</ToggleButton>
				))}
			</ToggleButtonGroup>
		</div>
	);
};

export default FilterTeams;
